import { render, staticRenderFns } from "./MyStatements.vue?vue&type=template&id=02c2e048&scoped=true&"
import script from "./MyStatements.vue?vue&type=script&lang=ts&"
export * from "./MyStatements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2e048",
  null
  
)

export default component.exports